/**
 * History Loading Placeholder Component
 * Displays skeleton loading placeholders for history list items
 */

import React from 'react';
import { spacing, backgroundColors } from '@/design-system/utils';

export const HistoryLoadingPlaceholder: React.FC = () => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: spacing[0],
        width: '100%',
        alignItems: 'flex-start',
      }}
      className='w-full md:w-[761px]'
    >
      {[1, 2, 3, 4, 5].map(index => (
        <div
          key={index}
          style={{
            display: 'flex',
            width: '100%',
            padding: spacing[4],
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '11px',
            borderRadius: '6px',
            borderBottom:
              index < 5 ? `1px solid ${backgroundColors.shade}` : 'none',
          }}
          className='w-full md:w-[761px]'
        >
          {/* Content wrapper matching HistoryItemContent layout */}
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              width: '100%',
            }}
          >
            {/* Left Section - Skeleton for text */}
            <div
              style={{
                flex: 1,
                minWidth: 0,
                maxWidth: '460px',
              }}
              className='md:max-w-[460px] max-w-[180px]'
            >
              <div
                style={{
                  height: '20px',
                  backgroundColor: backgroundColors.shade,
                  borderRadius: '4px',
                  width: index % 2 === 0 ? '80%' : '60%',
                  animation: 'pulse 1.5s ease-in-out infinite',
                }}
              />
            </div>
            {/* Right Section - Skeleton for date and actions */}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                gap: spacing[3],
                flexShrink: 0,
              }}
            >
              {/* Date skeleton */}
              <div
                style={{
                  height: '16px',
                  width: '80px',
                  backgroundColor: backgroundColors.shade,
                  borderRadius: '4px',
                  animation: 'pulse 1.5s ease-in-out infinite',
                }}
              />
              {/* Actions icon skeleton */}
              <div
                style={{
                  height: '24px',
                  width: '24px',
                  backgroundColor: backgroundColors.shade,
                  borderRadius: '4px',
                  animation: 'pulse 1.5s ease-in-out infinite',
                }}
              />
            </div>
          </div>
        </div>
      ))}
      <style jsx>{`
        @keyframes pulse {
          0%,
          100% {
            opacity: 1;
          }
          50% {
            opacity: 0.5;
          }
        }
      `}</style>
    </div>
  );
};
